import AOS from 'aos';
import { throttle, debounce } from 'underscore'; //https://underscorejs.org
import Modal from 'bootstrap/js/dist/modal';


// custom jquery below
jQuery(document).ready(function ($) {
    'use strict';

    // mobile breakpoint setting used below
    const mobileBreakpoint = 575;

    // FADE IN CONTENT ON PAGE LOAD
    setTimeout(function () {
        $('body').addClass('delayfade');
    }, 200);

    // animate on scroll init - https://michalsnik.github.io/aos/
    AOS.init();


    /*****************************************************
    **************** MENU FUNCTIONALITY ******************
    *****************************************************/
    const $body = $('body');
    const $navToggle = $('#navToggle');
    let logoClassScroller;

    $navToggle.click(function(e) {

        if( !$(e.currentTarget).hasClass('nav-open') ) {

            $(e.currentTarget).addClass('nav-open');
            $body.addClass('nav-open');

        } else {

            $(e.currentTarget).removeClass('nav-open');
            $body.removeClass('nav-open');

        }

    });

    // Logo and nav color change on scroll functionality
    const logoScrollController = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
        offset: 250
    })
        .setClassToggle('.color-scroller', 'scrolled')
        .addTo(logoScrollController);

    /**************** END MENU FUNCTIONALITY ******************/

    // WORK CATEGORIES MENU FOR MOBILE
    if( $('.work-categories li.cat-item ul.children').length ) {
        let catNavState = 'desktop';
        const $cTrigger = $('.work-categories li.cat-item > i');
        const $resetEls = $('.work-categories li.cat-item > i, .work-categories li.cat-item > ul.children');

        // SET NAVSATE / INIT
        const setCatNavState = function() {

            if( $(window).width() > mobileBreakpoint ) {

                catNavState = 'desktop';
                $resetEls.removeClass('open');

            } else {

                catNavState = 'mobile';

            }
        }

        $cTrigger.click(function(e) {
            const $cTarget = $(e.currentTarget);

            if( !$cTarget.hasClass('open') ) {

                $resetEls.removeClass('open');

                $cTarget.addClass('open').next('ul.children').addClass('open');

            } else {

                $cTarget.removeClass('open').next('ul.children').removeClass('open');

            }

        });

        setCatNavState();

        $(window).resize(
            debounce(setCatNavState, 300)
        );

    }
    // END WORK CATEGORIES MENU FOR MOBILE



    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p').each(function() {
        let string = $(this).html();
        string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
        $(this).html(string);
    });


    // ENDLESS CONTENT / LOOP ON SCROLL TO BOTTOM FUNCTIONALITY
    if( $('.page-looper').length ) {

        const $loopContainer = $(".post-loop-wrap");
        const $loopContent = $(".c-innerwrap").clone();
        const lcHeight = $loopContainer.outerHeight();
        let counter = 1;
        let loopNavState = 'desktop';

        // SET NAVSATE / INIT
        const setLoopNavState = function() {

            if( $(window).width() > mobileBreakpoint ) {

                loopNavState = 'desktop';

            } else {

                loopNavState = 'mobile';

            }
        }

        // clean up aos classes if cloned with animate attached
        $loopContent.find('.aos-init').removeClass('aos-animate');

        // scroll function
        const looperScroll = function() {

            if( loopNavState == 'desktop' ) {

                const documentHeight = document.body.scrollHeight;
                const currentScroll = window.scrollY + window.innerHeight;
                const modifier = lcHeight / 2;

                if( currentScroll + modifier >= documentHeight ) {

                    // doubled functions to smooth out and fix flickering issue
                    $loopContainer.append( $loopContent.clone() );
                    $loopContainer.append( $loopContent.clone() );

                    if( counter == 2 ) {

                        $(".c-innerwrap").first().remove();
                        $(".c-innerwrap").first().remove();

                        counter = 1;

                    }

                    counter++;

                }
            }

        }

        setLoopNavState();

        $(window).resize(
            debounce(setLoopNavState, 300)
        );

        const throttledScroll = throttle(looperScroll, 40);
        $(window).on('scroll', throttledScroll);

    }

    // BACK ARROW FUNCTIONALITY
    function getCookieValue(name) {
        let result = document.cookie.match("(^|[^;]+)\s*" + name + "\s*=\s*([^;]+)")
        return result ? result.pop() : ""
    }

    if( $('body.single-our-work').length ) {

        const $backBtn = $('.bck-btn-wrap a');

        if( getCookieValue( 'workPrevURL' ) ) {

            $backBtn.attr('href', getCookieValue( 'workPrevURL' ));

        }
    }

    if( $('body.single-post').length ) {

        const $backBtn = $('.bck-btn-wrap a');

        if( getCookieValue( 'blogPrevURL' ) ) {

            $backBtn.attr('href', getCookieValue( 'blogPrevURL' ));

        }
    }
    // END BACK ARROW FUNCTIONALITY


    if( $('.scrollbar-hider').length ) {

        document.querySelector('.scroller').scrollLeft = (document.querySelector('.scroller').scrollWidth - document.querySelector('.scroller').clientWidth) / 2

    }
});
